export { default } from './ReplacementSlider';
